import React, { useEffect, useState } from "react";
import axios from "axios";

const UserLocation = () => {
  const [address, setAddress] = useState("");
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  useEffect(() => {
    const fetchLocation = async () => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setCoordinates({ lat: latitude, lng: longitude });

          try {
            const apiKey = process.env.REACT_APP_GOOGLE_API_KEY; // 🔐 Replace with your API key

            const response = await axios.get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
            );
            if (process.env.NODE_ENV === "development") {
              console.log("Full Address:", response.data);
            }
            const fullAddress =
              response.data.results[0]?.formatted_address || "Address not found";
            setAddress(fullAddress);
          } catch (error) {
            console.error("Error fetching address:", error);
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    };

    fetchLocation();
  }, []);

  return (
    <div>
      <h2>My Location:</h2>
      <p>
        <strong>Coordinates:</strong> {coordinates.lat}, {coordinates.lng}
      </p>
      <p>
        <strong>Address:</strong> {address}
      </p>
    </div>
  );
};

export default UserLocation;
